import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TripService {

  constructor(private http : HttpClient) {

  }
  saveTrip(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/trips/save",request,{headers : headers,observe:"response"});
   }
   getTripList(userUid:any,status:any) {
      
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("status", status);

    return this.http.get( environment.API_URL + '/api/trips/triplist/'+userUid,{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  getApprovalInitiatedList(userUid:any,status:any) {
      
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("status", status);
    
    return this.http.get( environment.API_URL + '/api/trips/triplist/approvallevel1/'+userUid,{ observe : "body", params : httpParam,responseType : "json"})
    // return this.http.get( environment.API_URL + '/api/trips/triplist/approvalinitiated/'+userUid,{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  activeTrip(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/trips/activeTrip/save",request,{headers : headers,observe:"response"});
   }
  getActiveTrip(userUid:any) {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/trips/latesttrip/'+userUid,{ observe : "body", params : httpParam,responseType : "json"})
  }

  getTripByTripId(tripId:any) {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + "/api/trips/"+tripId,{ observe : "body", params : httpParam,responseType : "json"})
  }





  tripApproval(request:any) {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.post( environment.API_URL + '/api/tripapproval/save',request,{ observe : "body", params : httpParam,responseType : "json"})
  }
  tripBook(tripUid:any) {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.post( environment.API_URL + '/api/trips/book/'+tripUid,{ observe : "body", params : httpParam,responseType : "json"})
  }
  
  getCartTrip(tripUid:any,product:any) {
      
    let httpParam : HttpParams=new HttpParams();
       httpParam=httpParam.append("products", product);


    return this.http.get( environment.API_URL + '/api/trips/bookOrderDetail/trip/'+tripUid,{ observe : "body", params : httpParam,responseType : "json"})
  }
  
 
  getItemTrip(tripUid:any,product:any) {
      
    let httpParam : HttpParams=new HttpParams();
       httpParam=httpParam.append("products", product);

      //  /tripitemlist/{tripUid}
    return this.http.get( environment.API_URL + '/api/trips/tripitemlist/'+tripUid,{ observe : "body", params : httpParam,responseType : "json"})
  }
  getLowerTrip(requestId:any) {
      
    let httpParam : HttpParams=new HttpParams();
    return this.http.get( environment.API_URL + '/api/logs/lowestfare/'+requestId,{ observe : "body", params : httpParam,responseType : "json"})
  }
  

  saveReport(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/trip/report",result,{headers : headers,observe:"response"});
   }
   getReportList(param:any){
    let httpParam : HttpParams=new HttpParams();
    return this.http.get(environment.API_URL+"/api/trip/reportlist/"+param,{observe : "body", params : httpParam,responseType : "json"});
   }

   saveExpanse(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/expense",result,{headers : headers,observe:"response"});
   }
   getExpanseList(param:any){
    let httpParam : HttpParams=new HttpParams();
    return this.http.get(environment.API_URL+"/api/expenselist/"+param,{observe : "body", params : httpParam,responseType : "json"});
   }

   Send(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/create/ticket/"+result,{headers : headers,observe:"response"});
   }
   approveTripRequest(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/external/app/trips/update-status",request,{headers : headers,observe:"response"});
   }
   approveTripCancilRequest(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/trips/canceltrip",request,{headers : headers,observe:"response"});
   }
}
